/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Room_Model_HelpInputs */



/**
* | output |
* | --- |
* | "Help: the model works like this (name): in parentheses, the name of the element you want List of available elements:" |
*
* @param {Add_Room_Model_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const add_room_model_help = /** @type {((inputs?: Add_Room_Model_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Room_Model_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Help: the model works like this\n(name): in parentheses, the name of the element you want\nList of available elements: ")
	return /** @type {LocalizedString} */ ("Aide: le modèle marche comme ceci\n(nom): entre parenthèse le nom de l'element que vous souhaitez\nListe des elements disponible: ")
});